import { Injectable, inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { firstValueFrom } from "rxjs";
import { environment } from "@env/environment";
import { ApiRoutes } from "app/core/constants/api-routes";
import {
  CancellationTypeResponse,
  CancellationTypeResponseData,
  OrderCancellationPayload,
  OrderCancellationResponse,
} from "../models/order-cancellation.model";

@Injectable({ providedIn: "root" })
export class OrderCancelDataService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.API_CANCELLATION;

  async fetchCancellationTypes(
    tenantId: string,
  ): Promise<CancellationTypeResponseData[]> {
    const url = `${this.baseUrl}${ApiRoutes.order.cancellation.types(
      tenantId,
    )}`;

    try {
      const response = await firstValueFrom(
        this.http.get<CancellationTypeResponse>(url),
      );

      if (response.code === 3) {
        throw new Error("Cancellation types request failed with code 3");
      }

      if (response.code === 1) {
        return response.data;
      }

      return [];
    } catch (error: any) {
      if (error?.status === 404) {
        return [];
      }
      throw error;
    }
  }

  async cancelOrder(
    payload: OrderCancellationPayload,
  ): Promise<OrderCancellationResponse> {
    const url = `${this.baseUrl}${ApiRoutes.order.cancellation.submit(
      payload.tenantId,
    )}`;

    try {
      const response = await firstValueFrom(
        this.http.post<OrderCancellationResponse>(url, payload),
      );

      return response;
    } catch (error: any) {
      if (error?.status === 500) {
        throw new Error("Server error during order cancellation");
      }
      throw error;
    }
  }
}
